import {
    getAllMRIMachines,
    getPublicMRIMachines,
} from '../../services/apiService';
import {
    makeMRIMachinePublic,
    revokeMRIMachinePublic,
} from '../../services/apiService';
import { useEffect } from 'react';
import { MRIMachinePopulated } from '../room-overview/types';
import { useState } from 'react';
import SelectItem from '../general-components/SelectItem';
import { RoomOverviewAccordion } from '../ui/accordion/RoomOverviewAccordion';

const PublicMRIMachines = () => {
    const [machines, setMachines] = useState<MRIMachinePopulated[]>([]);

    useEffect(() => {
        getAllMRIMachines().then(setMachines);
    }, []);

    const handleTogglePublic = (isPublic: boolean, id: string) => {
        if (isPublic) {
            revokeMRIMachinePublic(id);
            setMachines(
                machines.map((machine) =>
                    machine._id === id
                        ? { ...machine, isPublic: false }
                        : machine
                )
            );
        } else {
            makeMRIMachinePublic(id);
            setMachines(
                machines.map((machine) =>
                    machine._id === id
                        ? { ...machine, isPublic: true }
                        : machine
                )
            );
        }
    };

    return (
        <div>
            {machines.map((machine) => (
                <div
                    className="flex flex-column align-center"
                    key={machine._id}
                >
                    <SelectItem
                        defaultChecked={machine.isPublic}
                        labelled={false}
                        value={machine._id}
                        type="checkbox"
                        onChange={() =>
                            handleTogglePublic(machine.isPublic, machine._id)
                        }
                    />
                    <RoomOverviewAccordion machine={machine} isPreview />
                </div>
            ))}
        </div>
    );
};

export default PublicMRIMachines;
